import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { useCallback } from 'react';
import { thunkGoToGameGuidePage } from '../../../redux/actions/gameGuideActions';
import { useAppDispatch, useAppSelector } from '../../../redux/store';
import { SUBTLE_MODAL_TEXT_COLOR } from '../../../styles/colors';
import { PLAYER_SERVER_SETTING_PROPERTIES } from '../../../types/playerServerSettingsTypes';
import { FormControlContainer } from '../../formControlContainer';
import { PowerPlayerFeatureIndicator } from './powerPlayerFeatureIndicator';
import { ServerSettingItemButton } from './serverSettingItemButton';
export const SettingModalItem = ({ onClose, settingType }) => {
    const dispatch = useAppDispatch();
    const settingLabel = useAppSelector((state) => state.selfData.playerServerSettingLabels[settingType]);
    const { name, description, isPowerPlayerOnly, gameGuidePageType } = PLAYER_SERVER_SETTING_PROPERTIES[settingType];
    const onClickMoreInfo = useCallback(() => {
        if (!gameGuidePageType) {
            return;
        }
        onClose();
        dispatch(thunkGoToGameGuidePage(gameGuidePageType));
    }, [onClose, dispatch, gameGuidePageType]);
    if (settingLabel === undefined) {
        // this setting (or all settings) have not been initialized from server
        console.warn(`Player server setting '${settingType}' not initialized while rendering Settings UI.`);
        return null;
    }
    return (_jsxs(FormControlContainer, { "aria-label": name, children: [_jsxs("div", { css: css `
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: space-between;
          flex-wrap: wrap;
          gap: 5px;
        `, children: [_jsx("div", { css: css `
            flex-grow: 1;
          `, children: _jsxs(Typography, { component: 'div', children: [_jsx("span", { "aria-hidden": true, children: name }), isPowerPlayerOnly && _jsx(PowerPlayerFeatureIndicator, {})] }) }), _jsx("div", { children: _jsx(ServerSettingItemButton, { settingType: settingType }) })] }), _jsx(Typography, { component: 'div', variant: 'subtitle2', css: css `
          color: ${SUBTLE_MODAL_TEXT_COLOR};
        `, children: description }), gameGuidePageType && (_jsx(Button, { size: 'small', variant: 'outlined', onClick: onClickMoreInfo, children: "More Info" }))] }));
};
